import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HisCoreSharedModule } from '../../../core/his-core-shared.module';
import { InputPersonalAgreementComponent } from './component/his-input-personal-agreement.component';


/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // primeng

        // HIS
        HisCoreSharedModule,
    ],

    declarations: [
        InputPersonalAgreementComponent,
    ],

    exports: [
        InputPersonalAgreementComponent,
    ]
    // NO PROVIDERS! Providers need to go into HisInputCoreModule
} )
export class HisInputPersonalAgreementSharedModule {

}
